// Shared helpers for the auth pages.

/** Error values may be a string or an object with .message (same normalisation as the mobile screens). */
export { msg } from "../../lib/errors";

// Same regex as screens/ForgotPasswordScreen.js.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Where to go after sign-in: the in-app page a signed-out (or unverified) visitor was sent away
 * from, carried in router state as `from`. Internal paths only; never back into /auth.
 */
export function returnPath(state) {
  const from = state?.from;
  const path = typeof from?.pathname === "string" ? from.pathname : "";
  if (!path.startsWith("/") || path.startsWith("//") || path.startsWith("/auth")) return null;
  return path + (typeof from.search === "string" ? from.search : "") + (typeof from.hash === "string" ? from.hash : "");
}

/** Router state to pass on every move between auth pages so `from` (above) survives the detour. */
export const carryFrom = (state) => (state?.from ? { from: state.from } : undefined);
